import { Sprout } from "lucide-react";

export default function Logo({ dark = false, className = "" }) {
  const color = dark ? "#FAFCFA" : "#0B281B";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <span
        className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#98D8BA]"
        aria-hidden
      >
        <Sprout className="h-5 w-5" style={{ color: "#0B281B" }} strokeWidth={2} />
      </span>
      <span
        className="font-heading text-xl font-bold tracking-tight"
        style={{ color }}
      >
        Sprig<span className="text-[#75C69F]"> Built</span>
      </span>
    </div>
  );
}
